import { ThemeProvider as MuiThemeProvider, CssBaseline } from '@mui/material';
import { createAppTheme } from './theme';

export const ThemeProvider = ({ children }) => {
  
  // Create theme based on current mode
  const theme = createAppTheme();

  return (
    <MuiThemeProvider theme={theme} defaultMode={"system"}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};

export default ThemeProvider;
